import {
  alpha,
  createTheme,
  PaletteType,
  responsiveFontSizes,
} from "@material-ui/core";
import dark from "./dark";
import light from "./light";

const themes = (type: PaletteType = "dark") => {
  const defaultTheme = type === "light" ? light : dark;

  return responsiveFontSizes(
    createTheme(
      {
        overrides: {
          MuiButton: {
            root: {
              textTransform: "initial",
            },
            textPrimary: {
              "&:hover": {
                background: `${alpha(
                  defaultTheme.palette.common.white,
                  0.08
                )} !important`,
              },
            },
          },
          MuiTooltip: {
            tooltip: {
              fontSize: 12,
              fontWeight: 500,
            },
            tooltipPlacementTop: {
              margin: `${defaultTheme.spacing(1, 0)} !important`,
            },
            tooltipPlacementBottom: {
              margin: `${defaultTheme.spacing(1, 0)} !important`,
            },
            tooltipPlacementLeft: {
              margin: `${defaultTheme.spacing(0, 1)} !important`,
            },
            tooltipPlacementRight: {
              margin: `${defaultTheme.spacing(0, 1)} !important`,
            },
          },
          MuiPaper: {
            rounded: {
              borderRadius: defaultTheme.spacing(1),
            },
          },
          MuiDialogTitle: {
            root: {
              padding: defaultTheme.spacing(1.5, 3),
            },
          },
          MuiDialogContent: {
            root: {
              padding: defaultTheme.spacing(1.5, 3),
            },
            dividers: {
              borderTopWidth: 4,
              borderBottomWidth: 4,
            },
          },
          MuiIconButton: {
            root: {
              color: defaultTheme.palette.text.secondary,
              borderRadius: 0,
              transition: defaultTheme.transitions.create("color"),
              textTransform: "none",
            },
          },
          MuiTouchRipple: {
            child: {
              borderRadius: 0,
            },
          },
          MuiOutlinedInput: {
            notchedOutline: {
              borderColor: "#8a8f94",
            },
          },
          MuiCheckbox: {
            root: {
              color: "#ffffff4d",
              "& svg": {
                width: 23,
                height: 23,
              },
            },
          },
          MuiSwitch: {
            colorPrimary: {
              "&.Mui-checked": {
                color: "#bdbdbd",
                "& + .MuiSwitch-track": {
                  opacity: 1,
                },
              },
              "&.Mui-disabled": {
                color: "#7a7a7a",
              },
            },
          },
          MuiSlider: {
            root: {
              color: "#8a8f94",
            },
            thumb: {
              color: "#8a8f94",
            },
            rail: {
              backgroundColor: defaultTheme.palette.primary.main,
            },
          },
          MuiMenu: {
            paper: {
              maxHeight: `calc(100% - ${defaultTheme.spacing(8)}px)`,
            },
          },
          MuiMenuItem: {
            root: {
              "&.Mui-selected": {
                color: defaultTheme.palette.primary.main,
                background: "none",
              },
            },
          },
          MuiListItem: {
            divider: {
              borderBottom: `1px solid ${defaultTheme.palette.text.disabled}`,
            },
          },
          MuiLink: {
            root: {
              fontWeight: 500,
            },
          },
          MuiFormHelperText: {
            contained: {
              marginLeft: 0,
              marginRight: 0,
            },
          },
        },
        props: {
          MuiFormControl: {
            margin: "dense",
          },
          MuiTooltip: {
            arrow: true,
            disableFocusListener: true,
          },
          MuiDrawer: {
            keepMounted: true,
          },
        },
      },
      defaultTheme
    )
  );
};

export default themes;
